<div class="flex gap-2">
  <button mat-flat-button class="bg-gray-30" (click)="showPrint('article', $event)" [disabled]="isDisabled">
    <mat-icon aria-hidden="true" class="text-primary">article</mat-icon>
    問題をまとめて印刷
  </button>
  <button mat-flat-button class="bg-gray-30" (click)="showPrint('spellcheck', $event)" [disabled]="isDisabled">
    <mat-icon aria-hidden="true" class="text-primary">spellcheck</mat-icon>
    研究・解答をまとめて印刷
  </button>
</div>
